import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../actions/actions';
import { AlertForm, FormInput, FormCardGroup, FormTextarea, FormButton, CheckboxValues, RadioValues } from '../Helpers/Form';
import DayOfWeek from '../Helpers/Storage/DayOfWeek.json';
import RequestPlace from '../Helpers/Storage/RequestPlace.json';
import SingleChoise from '../Helpers/Storage/SingleChoise.json';

import './Request.css';

class Request extends Component {
  constructor(props) {
    super(props);
    props.getPets();
  }
  render() {
    const {
      requestVm,
      requestChange,
      pateRequest,
      match,
      petsVm,
      errorVm: { success }
    } = this.props;
    const {
      pets2Pate, from, to, message, requestPlace,
      selectedDayOfWeek,
      cleanIncluded
    } = requestVm;
    const { userId } = match.params;
    return (
      <div className="request">
        <h1>Anfrage</h1>
        <AlertForm
          onChange={({ value, name }) => { requestChange(name, value); }}
          onSubmit={() => pateRequest({
            ...requestVm,
            selectedDayOfWeek: Array.from(selectedDayOfWeek),
            pets2Pate: Array.from(pets2Pate),
            cleanIncluded: requestVm.cleanIncluded.size !== 0
          }, userId)}
        >
          <FormCardGroup type="card" text="Wähle aus" required>
            <CheckboxValues
              required
              selectedValues={pets2Pate}
              possibleValues={Array.from(petsVm).map(([key, value]) => ([key, value.name]))}
              name="pets2Pate"
            />
          </FormCardGroup>
          <FormCardGroup type="card" text="Komplettreinigung für Käfig/Toilette/Aquarium etc?">
            <CheckboxValues
              selectedValues={cleanIncluded}
              possibleValues={SingleChoise}
              name="cleanIncluded"
            />
          </FormCardGroup>
          <FormCardGroup type="card" text="Betreuungs Ort" required>
            <RadioValues
              required
              selectedValue={requestPlace}
              possibleValues={RequestPlace}
              name="requestPlace"
            />
          </FormCardGroup>
          <FormInput type="date" text="Startdatum" name="from" value={from} required />
          <FormInput type="date" text="Enddatum" name="to" value={to} required />
          <FormCardGroup type="card" text="Falls periodisch, bitte Wochentage wählen">
            <CheckboxValues selectedValues={selectedDayOfWeek} possibleValues={DayOfWeek} name="selectedDayOfWeek" />
          </FormCardGroup>
          <FormTextarea text="Persönliche Nachricht:" value={message} name="message" required />
          {!success && (<FormButton text="Abschicken" />)}
        </AlertForm >
      </div>
    );
  }
}

export default connect(
  state => ({ ...state.requestReducer, ...state.petsReducer, ...state.alertReducer }),
  dispatch => bindActionCreators(Actions, dispatch)
)(Request);



// WEBPACK FOOTER //
// ./src/pages/Request/index.js